"use client"


import { useEffect } from "react"
import TagPill_2 from "../Atoms/Tags/TagPill_2";
import { IndigoButton, TealButton } from "../Atoms/Buttons/ColorButtons";

const JobAlertBox = ({lang, tags}) => {
tags = tags.filter(tag=> tag.tag_level === 1)




          let tagCheck = (id, href) => {

               // marks as checked automatically when satisfying criteria
               let elementId = document.getElementById(`group_${id}`)
                
               // applies CSS style to className
               let elementClass = document.querySelector(`label[for="group_${id}"]`).classList;
           
           
                // href arg refers to location from which check was done. Location can either be 'filterJobs (sidebar)', automatically on /job/ through skillset selected or manually (mouse) on the component. If href==menu (sidebar) clicking same menu item once more will not uncheck the tag (can only be done manually)
             
               if (href === 'menu' || href === 'job') {
                  elementId.checked = true
                  elementClass.add('checked')
               }
           
               // if checked, either replace the unchecked className with check if unchecked before or add 'checked' className
               if (elementId.checked) {
                if(elementClass.contains('unchecked')){
                   elementClass.replace('unchecked', 'checked')}
                   else{
                      elementClass.add('checked')
                   }
               }
               else if (!elementId.checked) {
                  elementClass.replace('checked', 'unchecked')
               }
           
           }


     
     return (
     <div className="w-full">




<form action="https://serch.us17.list-manage.com/subscribe/post?u=6982ffc361ac913387cd05d72&amp;id=16e9361996" method="post" id="mc-embedded-subscribe-form2" name="mc-embedded-subscribe-form" className="validate" target="_blank" noValidate>


<TagPill_2 caption={'C#'} groupId={1} defaultChecked={tags.some(tag => tag.tag_name.toUpperCase() === 'C#')}/>
<TagPill_2 caption={'Java'} groupId={128} defaultChecked={tags.some(tag => tag.tag_name.toUpperCase() === 'JAVA')} />
<TagPill_2 caption={'Mobile'} groupId={2} defaultChecked={tags.some(tag => tag.tag_name.toUpperCase() === 'MOBILE')}/>
<TagPill_2 caption={'PHP'} groupId={4} defaultChecked={tags.some(tag => tag.tag_name.toUpperCase() === 'PHP')}/>
<TagPill_2 caption={'Python'} groupId={8} defaultChecked={tags.some(tag => tag.tag_name.toUpperCase() === 'PYTHON')}/>
<TagPill_2 caption={'NodeJS'} groupId={256} defaultChecked={tags.some(tag => tag.tag_name.toUpperCase() === 'NODEJS')}/>
<TagPill_2 caption={'NodeJS'} groupId={4096} defaultChecked={tags.some(tag => tag.tag_name.toUpperCase() === 'RUBY')}/>
<TagPill_2 caption={'FrontEnd'} groupId={32} defaultChecked={tags.some(tag => tag.tag_name.toUpperCase() === 'FRONTEND')}/>
<TagPill_2 caption={'DevOps'} groupId={1024} defaultChecked={tags.some(tag => tag.tag_name.toUpperCase() === 'SYSTEM & DEVOPS')}/>
<TagPill_2 caption={'System Administration'} groupId={64} defaultChecked={tags.some(tag => tag.tag_name.toUpperCase() === 'SYSTEM & DEVOPS')}/>
<TagPill_2 caption={'Application Support'} groupId={512} defaultChecked={tags.some(tag => tag.tag_name.toUpperCase() === 'SUPPORT')}/>
<TagPill_2 caption={'Technical Support'} groupId={2048} defaultChecked={tags.some(tag => tag.tag_name.toUpperCase() === 'SUPPORT')}/>
<TagPill_2 caption={'QA & Automation'} groupId={16} defaultChecked={tags.some(tag => tag.tag_name.toUpperCase() === 'QA & AUTOMATION')}/>
<TagPill_2 caption={'Business & Analysis'} groupId={8192} defaultChecked={tags.some(tag => tag.tag_name.toUpperCase() === 'BUSINESS & ANALYSIS')}/>
<TagPill_2 caption={'Data & Analytics'} groupId={16384} defaultChecked={tags.some(tag => tag.tag_name.toUpperCase() === 'DATA & ANALYTICS')}/>

{/* <label className="tagbox-mailchimp" for="group_1">
<input type="checkbox" id="group_1" name="group[22182][1]" value="1" className="av-checkbox" onClick={()=>tagCheck(1)}/>
C#
</label> 


<label className="checkbox tagbox-mailchimp" for="group_128">
<input type="checkbox" id="group_128" name="group[22182][128]" value="1" className="av-checkbox" onClick={()=>tagCheck(128)}/>
Java
</label>  */}

{/* <label className="checkbox tagbox-mailchimp" for="group_2">
<input type="checkbox" id="group_2" name="group[22182][2]" value="2" className="av-checkbox" onClick={()=>tagCheck(2)}/>
Mobile 
</label>  */}

{/* <label className="checkbox tagbox-mailchimp" for="group_4">
<input type="checkbox" id="group_4" name="group[22182][4]" value="4" className="av-checkbox" onClick={()=>tagCheck(4)}/>
PHP 
</label>  */}

{/* <label className="checkbox tagbox-mailchimp" for="group_8">
<input type="checkbox" id="group_8" name="group[22182][8]" value="8" className="av-checkbox" onClick={()=>tagCheck(8)}/>
Python 
</label>  */}


{/* <label className="checkbox tagbox-mailchimp" for="group_256">
<input type="checkbox" id="group_256" name="group[22182][256]" value="256" className="av-checkbox" onClick={()=>tagCheck(256)}/>
NodeJS 
</label>  */}

{/* <label className="checkbox tagbox-mailchimp" for="group_32">
<input type="checkbox" id="group_32" name="group[22182][32]" value="32" className="av-checkbox" onClick={()=>tagCheck(32)}/>
FrontEnd 
</label> */}

{/* <label className="checkbox tagbox-mailchimp" for="group_1024">
<input type="checkbox" id="group_1024" name="group[22182][1024]" value="1024" className="av-checkbox" onClick={()=>tagCheck(1024)}/>
DevOps 
</label>  */}

{/* <label className="checkbox tagbox-mailchimp" for="group_64">
<input type="checkbox" id="group_64" name="group[22182][64]" value="64" className="av-checkbox" onClick={()=>tagCheck(64)}/>
System Administration 
</label>  */}

{/* <label className="checkbox tagbox-mailchimp" for="group_512">
<input type="checkbox" id="group_512" name="group[22182][512]" value="512" className="av-checkbox" onClick={()=>tagCheck(512)}/>
Application Support 
</label> */}

{/* <label className="checkbox tagbox-mailchimp" for="group_2048">
<input type="checkbox" id="group_2048" name="group[22182][2048]" value="2048" className="av-checkbox" onClick={()=>tagCheck(2048)}/>
Technical Support
</label> */}

{/* <label className="checkbox tagbox-mailchimp" for="group_16">
  <input type="checkbox" id="group_16" name="group[22182][16]" value="16" className="av-checkbox" onClick={()=>tagCheck(16)}/>
  QA / Automation 
  </label>  */}

<br/><br/>

<div id="mc_embed_signup_scroll ">

{/* mailchimp-input */}
  <input 
     type="text" 
     name="FNAME" 
     className="w-full border rounded text-sm py-1 px-2 mb-1 dark:bg-slate-900 dark:border-slate-800 dark:text-gray-400 focus:outline-none" 
     id="mce-FNAME" 
     placeholder={lang==='fr' ? 'Prénom' : 'First Name'} 
     required
     />

  <input 
     type="email" 
     name="EMAIL" 
     className="w-full border rounded text-sm py-1 px-2 dark:bg-slate-900 dark:border-slate-800 dark:text-gray-400 focus:outline-none" 
     id="mce-EMAIL" 
     placeholder={lang==='fr' ? 'Adresse Courriel' : 'Email Address'}
     required
     />

  <div hidden=""><input type="hidden" name="tags" defaultValue="6515728"/></div>

  <div style={{position: 'absolute', left: '-5000px'}} aria-hidden="true">

     <input type="text" name="b_6982ffc361ac913387cd05d72_16e9361996" tabIndex="-1" defaultValue=""/></div>

<div className="text-right mt-2">
<TealButton caption={lang==='fr' ? "S'inscrire" : 'Subscribe'}/>
</div>

</div>
</form>


</div>
     )
}

export default JobAlertBox